<script>
  import {createEventDispatcher} from 'svelte';
  import classNames from 'classnames';

  const dispatch = createEventDispatcher();

  export let label = '';
  export let type = null;
  export let screen = null;
  export let navigation = null;
  export let customClass = '';
  export let disabled = false;

  $: buttonClass = classNames(
    'scmp_Button',
    customClass,
    {
      [`scmp_Button--${type}`]: type
    },
    {'scmp_Button--disabled': disabled}
  );
  const handleClick = () => dispatch('buttonClick', {type, navigation, screen});
</script>

<input on:click={handleClick} {disabled} value={label} type="button" class={buttonClass} />
